import store from './index';

export function resetStore() {
  // Commit CLEAR_STATE to each module that supports it
  store.commit('assessment/CLEAR_STATE');
  store.commit('actionCentre/CLEAR_STATE');
  store.commit('discussions/CLEAR_STATE');
  store.commit('invite/CLEAR_STATE');
  store.commit('emergingThreats/CLEAR_STATE');
  // Commit FLUSH to each module that supports it
  store.commit('activityFeed/activityItems/FLUSH');
  store.commit('risks/riskNotes/FLUSH');
  store.commit('uploads/files/FLUSH');
}
